import React from 'react';
import styles from './ShinyText.module.css';

const ShinyText = ({ text, disabled = false, speed = 5, className = '', style = {} }) => {
  const animationDuration = `${speed}s`;

  return (
    <span
      className={`${styles.shinyText} ${disabled ? styles.disabled : ''} ${className}`}
      style={{ ...style, animationDuration }}
    >
      {text}
    </span>
  );
};

export default ShinyText;

